class VideoPlayerModalController {
    
    private close:Function; //injected from modal-service
    private videoUrl:string;
    
	// @ngInject
	constructor(
	    private $sce	 : ng.ISCEService
	){}
	
	public $onInit = () => {
		
	}
	
	//method to allow all media from non secure urls
	public secureUrl = ( src ) => {
		return this.$sce.trustAsResourceUrl(src);
	}
	
    private closeModal = () =>{
		this.close();
	}
    
}

class VideoPlayerModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    videoUrl: "<",
		close:'='
	};

	public controller = VideoPlayerModalController;
	public controllerAs = 'videoPlayerModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/video-player.html';

	public static Factory() {
		return () => new this();
	}
}

export { VideoPlayerModal };
